module.exports = __webpack_public_path__ + "static/media/policy_settings_document_categories_manage.8f289525.svg";